import { reactive, ref, onBeforeUnmount } from '@vue/composition-api'


const useInfiniteScroll = (loadMoreCallback) => {
  const sentinel = ref(null)
  const hook = reactive({
    observer: null,
  });

  // =>  METHODS
  const stopInfiniteScroll = () => {
    if (!hook.observer) {
      return;
    }

    hook.observer.disconnect();
    hook.observer = null;
  };

  const initInfiniteScroll = () => {
    hook.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadMoreCallback();
      }
    },
    {
      root: null,
      rootMargin: "0px 0px 200px 0px" // triggers 200px before end of page
    });

    hook.observer.observe(sentinel.value);
  };

  const manageInfiniteScroll = (nbItems, total) => {
    if ( nbItems === 0) {
      stopInfiniteScroll();

      return;
    }

    if (nbItems >= total) {
      stopInfiniteScroll();

      return;
    }
  
    if (hook.observer) { // InfiniteScroll is active
      return;
    }
    
    initInfiniteScroll();
  };

  // =>  COMPUTED

  // =>  WATCH

  // =>  HOOKS
  onBeforeUnmount(() => {
    hook.observer && hook.observer.disconnect()
  })

  // =>  DATA
  return { manageInfiniteScroll, sentinel };
};

export default useInfiniteScroll;
